import { gql } from "@apollo/client";

export const REQUEST_APPLICATION_CONFIGS = gql`
  query requestApplicationConfigs {
    elasticsearchEnabled
    environment
    account {
      featureFlags {
        enabled
        key
      }
      id
      name
      paymentPlan
      supportEmail
      actor {
        id
        plainId
        name
        firstName
        email
        avatar
        role
        teams {
          nodes {
            id
            name
          }
        }
      }
    }
  }
`;
